import React from 'react';
import '../../styles/teacherdashboard/TeacherWelcomeBanner.css';

const TeacherWelcomeBanner = () => {
  return (
    <div className="welcome-banner">
      <h2>Welcome Back!</h2>
    </div>
  );
};

export default TeacherWelcomeBanner;
